export default __webpack_public_path__ + "static/media/ellipse_testimony.3725eb57.svg";